import { t } from "ttag";

import { BASE_ROUTE, ROUTES } from "@/app/router";
import {
  AddCircleIcon,
  CalendarMinimalisticIcon,
  Header,
  RestartCircleIcon,
} from "@/shared/ui";

interface ScheduleConsultationHeaderProps {
  isReschedule?: boolean;
}

export const ScheduleConsultationHeader = ({
  isReschedule,
}: ScheduleConsultationHeaderProps) => {
  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Breadcrumb
          links={[
            {
              href: BASE_ROUTE.CONSULTATIONS,
              icon: CalendarMinimalisticIcon,
              label: t`Consultations`,
            },
            {
              href: ROUTES.CONSULTATIONS.SCHEDULE,
              icon: isReschedule ? RestartCircleIcon : AddCircleIcon,
              label: isReschedule
                ? t`Reschedule consultation`
                : t`Schedule new consultation`,
            },
          ]}
        />

        <Header.Title>
          {isReschedule ? t`Reschedule appointment` : t`New Consultation`}
        </Header.Title>
      </Header.Content>
    </Header.Root>
  );
};
